import React from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Checkbox } from '../ui/checkbox';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const SDOH_CATEGORIES = [
  "Food Security", "Housing & Shelter", "Utilities", "Healthcare Access", "Mental Health",
  "Substance Use", "Legal / Immigration", "Employment / Income", "Transportation",
  "Education / ESL", "Childcare / Family Support", "Violence / Safety", "Digital Access"
];

const BasicInfoSection = ({ formData, onChange, onMultiSelect }) => (
  <Card className="rounded-2xl border-[#E0D6C8]">
    <CardHeader className="pb-4">
      <CardTitle className="text-lg font-['Manrope']">Basic Information</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label className="required">Resource Name</Label>
        <Input data-testid="resource-name-input" placeholder="e.g., Community Food Pantry" value={formData.resource_name} onChange={(e) => onChange('resource_name', e.target.value)} className="rounded-xl mt-1.5" required />
      </div>
      <div>
        <Label className="required">Organization</Label>
        <Input data-testid="organization-input" placeholder="e.g., Boston Health Care for the Homeless" value={formData.organization} onChange={(e) => onChange('organization', e.target.value)} className="rounded-xl mt-1.5" required />
      </div>
      <div>
        <Label className="required">Primary SDOH Category</Label>
        <Select value={formData.primary_sdoh_category} onValueChange={(v) => onChange('primary_sdoh_category', v)}>
          <SelectTrigger data-testid="primary-category-select" className="rounded-xl mt-1.5"><SelectValue placeholder="Select category" /></SelectTrigger>
          <SelectContent>{SDOH_CATEGORIES.map(cat => (<SelectItem key={cat} value={cat}>{cat}</SelectItem>))}</SelectContent>
        </Select>
      </div>
      <div>
        <Label>Secondary Categories</Label>
        <div className="grid grid-cols-2 gap-2 mt-2">
          {SDOH_CATEGORIES.filter(c => c !== formData.primary_sdoh_category).map(cat => (
            <div key={cat} className="flex items-center space-x-2">
              <Checkbox id={`secondary-${cat}`} data-testid={`secondary-category-${cat}`} checked={formData.secondary_sdoh_categories?.includes(cat)} onCheckedChange={(checked) => onMultiSelect('secondary_sdoh_categories', cat, checked)} />
              <label htmlFor={`secondary-${cat}`} className="text-sm text-[#5A5A5A]">{cat}</label>
            </div>
          ))}
        </div>
      </div>
      <div>
        <Label className="required">Client-Facing Description</Label>
        <Textarea data-testid="description-input" placeholder="Description that can be shared with clients..." value={formData.client_facing_description} onChange={(e) => onChange('client_facing_description', e.target.value)} className="rounded-xl mt-1.5 min-h-[100px]" required />
      </div>
    </CardContent>
  </Card>
);

export default BasicInfoSection;
